// @flow
import React from 'react';
import isEmpty from 'lodash/isEmpty';
import { connect } from 'react-redux';

import { openLightbox } from '../../redux/actions/lightboxStateActions';

type Props = {
  src: string,
  primaryImageUrl?: string,
  openLightbox: ({ images: Array<string> }) => void,
  srcIndex?: number,
  images?: typeof undefined | Array<string>,
};

const ImgBox = (props: Props) => {
  const { openLightbox, primaryImageUrl, ...imgAttributes } = props;

  const handleClick = () => {
    const { src, srcIndex, images } = imgAttributes;

    if (primaryImageUrl) {
      return openLightbox({
        images: [primaryImageUrl],
      });
    }

    openLightbox({
      images: !isEmpty(images) ? images : [src],
      imgIndex: srcIndex,
    });
  };

  //eslint-disable-next-line
  return <img {...imgAttributes} onClick={handleClick} />;
};

const mapDispatchToProps = dispatch => ({
  openLightbox: ({ images, imgIndex }) => dispatch(openLightbox({ images, imgIndex })),
});

export default connect(
  null,
  mapDispatchToProps
)(ImgBox);



// WEBPACK FOOTER //
// ./src/components/Lightbox/ImgBox.jsx